import cloudinary from '/node_modules/cloudinary-video-player/dist/cld-video-player.light.min.js';

try {
	let videos = $('video');
	videos.each(function() {
		let v = $(this);

		if (v.hasClass('plain-video') == false) {
			let container = v.closest('.trailer-video').first();
			let info = container.find('.bottom-info');

			cloudinary.videoPlayer(v.attr('id'), {
				cloud_name: 'da98qyoif',
				showLogo: false,
			});

			v.on('play', function() {
				info.css('display', 'none');
			}).on('pause', function() {
				info.css('bottom', '50px');
				info.css('display', 'block');
			});
		}
	});
}
catch (error) {
	console.error(error);
}
